import React, { memo, type FC } from "react";
import { NutritionMacroTableColumn } from "../molecules/NutritionMacroTableColumn";
import { useTranslation } from "react-i18next";

export type NutritionMacroTableProps = {
  isLoading?: boolean;
  fibers: number;
  fats: number;
  carbohydrates: number;
  calories: number;
  proteins: number;
  weight?: number;
};

export const NutritionMacroTable: FC<NutritionMacroTableProps> = memo(
  ({ isLoading, fibers, fats, carbohydrates, calories, proteins, weight }) => {
    const { t } = useTranslation();

    return (
      <dl className={`mt-4 mb-4 grid grid-cols-2 md:grid-cols-5 gap-4`}>
        <NutritionMacroTableColumn
          isLoading={isLoading}
          name={t("contexts.nutrition.calories")}
          primaryValue={calories}
          primaryUnit="kcal"
        />
        <NutritionMacroTableColumn
          isLoading={isLoading}
          name={t("contexts.nutrition.proteins")}
          primaryValue={proteins}
          primaryUnit="gr"
          secondaryValue={proteins / 180}
          secondaryUnit="gr/kg"
        />
        <NutritionMacroTableColumn
          isLoading={isLoading}
          name={t("contexts.nutrition.carbohydrates")}
          primaryValue={carbohydrates}
          primaryUnit="gr"
          secondaryValue={carbohydrates / 180}
          secondaryUnit="gr/kg"
        />
        <NutritionMacroTableColumn
          isLoading={isLoading}
          name={t("contexts.nutrition.fats")}
          primaryValue={fats}
          primaryUnit="gr"
          secondaryValue={fats / 180}
          secondaryUnit="gr/kg"
        />
        <NutritionMacroTableColumn
          isLoading={isLoading}
          name={t("contexts.nutrition.fibers")}
          primaryValue={fibers}
          primaryUnit="gr"
          secondaryValue={fibers / 180}
          secondaryUnit="gr/kg"
        />
      </dl>
    );
  }
);
